<div class="grid" [class]="onTablet() ? 'flex justify-content-center px-2' : ''">
	<div *ngFor="let site of sitesOrder" [class]="onExtendedMobile() ? 'w-full' : 'mx-2'">
		<!-- MOBILE -->
		<app-site-card-mobile *ngIf="onExtendedMobile()" [site]="site" [fromDialogSelector]="true" (closeDialog)="closeDialog()"></app-site-card-mobile>

		<!-- DESKTOP -->
		<app-site-card-desktop-tablet *ngIf="!onExtendedMobile()" [site]="site" [fromDialogSelector]="true" (closeDialog)="closeDialog()"></app-site-card-desktop-tablet>
	</div>
</div>